/**
 * Offers various scopes and sets background and defaults in foreign stores
 * created by herbert
 */

// the whole file is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

//window.console.log = function() {};

import React from 'react';
//import ReactDOM from 'react-dom';
import Reflux from 'reflux';

import * as config from '../../../config.js';
import '../../../config-sizes.js';
import * as scssConfig from '../../../config-scss.js';
import * as stepConfig from '../../../config-steps.js';

import stepActions from '../../slxstep/actions/step-actions.js';
import stepStore from '../../slxstep/stores/step-store.js';

import optionActions from '../actions/option-actions.js';
import optionStore from '../stores/option-store.js';

import steleActions from  '../actions/stele-actions.js';
import steleStore from '../stores/stele-store.js';

import viewActions from '../actions/view-actions.js';
import viewStore from '../stores/view-store.js';

import StelePart from '../StelePart.js';
import steleSVG from '../SteleSVG.js';

import T from '../../../nls/translate.js';


import SizeOption from './for-stele/size-option.jsx';
import mapParts from './for-stele/parts.jsx';
import TheThing from './for-stele/the-thing.jsx';
import renderCharging from './for-stele/charging.jsx';
import renderBottom from './for-stele/bottom.jsx';

import chargingOptions from './for-stele/charging-options.jsx';

const ChargingOptionsObject = {charging: true, idxs: {parent: null, child: null}};

const deltaClick = 7;

/**Array.<HTMLElement>*/ const parentRefs = [];
/**Array.<Array.<HTMLElement>>*/ const childRefs = [];

export default React.createClass({
	propTypes: {
		datasheet: React.PropTypes.bool,
		showInfo: React.PropTypes.func
	},
	mixins: [
		Reflux.connect(steleStore, 'data'), // this.state.data entspricht parameter von trigger() bei output: des stores,
		                                    // hier: ein Array mit StepPart-Elementen
		Reflux.connect(stepStore, 'stepdata'),
		Reflux.connect(optionStore, 'options'),
		Reflux.connect(viewStore, 'view')
	],
	getDefaultProps: function() {
		return {datasheet: false};
	},
	getInitialState: function() {
		return {
			pos: {x: 0, y: 0},
			dragging: false,
			rel: null // position relative to the cursor
		};
	},
	/*eslint react/sort-comp: 0 */
	//// we could get away with not having this (and just having the listeners on
	//// our div), but then the experience would be possibly be janky. If there's
	//// anything w/ a higher z-index that gets in the way, then you're toast,
	//// etc.
	componentDidMount: function() {
		document.addEventListener('mousedown', this.onMouseDown);
		document.addEventListener('mousemove', this.onMouseMove);
		document.addEventListener('mouseup', this.onMouseUp);
		window.addEventListener('resize', this.onResize);
		window.addEventListener('orientationchange', this.onResize);
	},
	componentWillUnmount: function() {
		document.removeEventListener('mousedown', this.onMouseDown);
		document.removeEventListener('mousemove', this.onMouseMove);
		document.removeEventListener('mouseup', this.onMouseUp);
		window.removeEventListener('resize', this.onResize);
		window.removeEventListener('orientationchange', this.onResize);
	},
	componentDidUpdate: function() {
		if(this.refs.vmBox)
			this.vmBox = this.refs.vmBox.getBoundingClientRect();
		if(this.refs.dropzone)
			this.dzRect = this.refs.dropzone.getBoundingClientRect();
		if(this.refs.draggBox && this.state.dragging) {
			const rect = this.refs.draggBox.getBoundingClientRect();
			this.draggCenter = ((rect.top + rect.bottom) / 2);
		}
	},
	// wrap action
	commitTemporary: function(cfg, centerY, parentPositions, parentIdx, childPositions, childIdx) { // eslint-disable-line react/sort-comp
		this.justAdded = !this.state.draggingRemoved ? cfg: null;
		steleStore.commitTemporary(cfg, centerY, parentPositions, parentIdx, childPositions, childIdx);
	},
	/**
	 *	start Dragg of a new part
	 * @param{StelePartCfg} cfg             configuration of piece to add ie. that signaled start of drag
	 * @param{TextRect}               box                   client box of issuing html element
	 * @param{MouseEvent}   ev              mouseDownEvent
	 * @param{Boolean}                removed       cfg got removed from stele
	 * @param{Number}                         [x]                   x position, supplied if removed is true
	 * @param{Number}                         [y]                   y position, supplied if removed is true
	 */
	startDragAdd: function(cfg, box, ev, removed, x, y) {
		if (cfg.name === config.PART_MODUL_CHARGING_NAME)
			viewActions.viewBottom();
		else
			viewActions.viewHead();

		//console.log("startDragAdd", cfg, box, ev);
		this.draggCenter = null;

		//if (ev.buttons !== 1) return; // only left mouse button TEST mit React auf Safari nicht möglich da buttons fehlt
		// und which nicht weitergegeben wird

		if(this.state.options.options)
			optionActions.clear();
		this.setState({
			draggingRemoved: removed,
			draggCfg: cfg,
			dragging: true,
			rel: {
				x: 0,
				y: 0
			},
			pos: {
				x: ev.pageX,
				y: ev.pageY
			}
		});
		ev.stopPropagation();
		ev.preventDefault();
	},
	/**
	 *
	 * @param{Number} 		parentIdx parent index of element to move
	 * @param{Number} 		childIdx	child index of child-element to move or null
	 * @param{MouseEvent} ev  			mouseDownEvent
	 * @param{Number}     [x]       x position, supplied if removed is true
	 * @param{Number}     [y]       y position, supplied if removed is true
	 */
	startDraggMove: function(parentIdx, childIdx, ev, x, y) {
		// cfg berechnen
		const box = childIdx === null ? parentRefs[parentIdx] : childRefs[parentIdx][childIdx];
		const cfg = childIdx === null ? Object.assign({}, this.state.data.active[parentIdx].cfg, {childs: this.state.data.active[parentIdx].children}) : this.state.data.active[parentIdx].children[childIdx].cfg;
		steleStore.remove(parentIdx, childIdx);
		this.startDragAdd(cfg, box, ev, true, x, y);
	},
	startDraggMoveCharging: function(ev, x, y) {
			steleStore.removeCharging();
			this.startDragAdd(config.PART_MODUL_CHARGING, null, ev, x, y);
	},
	dz: function(e) {
		const dzR = this.dzRect;
		return (dzR && e.pageX > dzR.left && e.pageX < dzR.right && e.pageY > dzR.top && e.pageY < dzR.bottom);
	},
	onMouseDown: function(e) {
		if(this.dz(e)) {
			this.dzTouch = true; // mouseEnter ignorieren, wird von dropzone nicht verwendet
			this.onDropzoneMouseDown(e);
		}

		if(e.which !== 1 )
		 return;
		//console.log(this.vmBox);
		if (this.state.options.options &&
				e.target.className.substr(0, 17) !== 'slx-stele-options' && e.target.className.substr(0, 24) !== 'sprity-slx-stele-options' &&
				this.state.stepdata.name !== stepConfig.STEP_PARAMETERS) {
			optionActions.clear();
		}

		if (e.target.className === 'slxstele-toolbar__rotate') {
			this.globalRotation = {r: this.state.data.rotation, x: e.pageX, y: e.pageY};
		} else if (e.target.className === 'slx-stele-height__handle') {
			this.moveHeight = {y: e.pageY, height: this.state.data.height};
		} else {
			const target = e.target.className.substr(22, 1); // slx-stele-params__spotA-...
			const a = target === 'A';
			const b = !a && target === 'B';
			if( (a && this.state.options.spotA) || (b && this.state.options.spotB) ) {
				const idxs = this.state.options.options.idxs;
				const spot = a ?
						this.state.data.active[idxs.parent].children[idxs.child].a :
						this.state.data.active[idxs.parent].children[idxs.child].b;
				this.moveSpot = {
					a: a,
					x: e.pageX,
					y: e.pageY,
					xx: spot.x,
					yy: spot.y
				};
			}
		}
	},
	onMouseUp: function(e) {
		//console.log(e, "*u", e.touch, e.which, this.dz(e));
		if(this.dz(e)) {
			this.onDropzoneMouseUp(e);
		}
		this.draggCenter = null;
		if(this.justAdded) { // supress render() as it will get called from the store
			this.state.dragging = false;
			this.state.dragCfg = false;
			e.stopPropagation();
			e.preventDefault();
		} else if(this.state.dragging) {
			this.setState({dragging: false, draggCfg: null});
			e.stopPropagation();
			e.preventDefault();
		} else if(this.rotating || this.globalRotation || this.moveSpot || this.moveHeight) {
			this.rotating = null;
			this.globalRotation = null;
			this.moveSpot = null;
			this.moveHeight = null;
			e.stopPropagation();
			e.preventDefault();
		}
	},
	onMouseMove: function(e) {
		//console.log(e, "mm", e.touch, e.which, this.dz(e), this.dzTouch);
		if(this.dz(e)) {
			this.onDropzoneMouseMove(e);
			this.dzTouch = true; // MouseEnter ignorieren, wird von dropzone nicht genutzt
		} else if(this.dzTouch) {
			this.dzTouch = false;
			this.onDropzoneMouseLeave(e);
		}
		if(e.which === 1) {
			if (this.rotating) {
				if (this.state.options.options) {
					const delta = (e.pageY - this.rotating.y + e.pageX -this.rotating.x) % 360;
					this.rotating.x = e.pageX;
					this.rotating.y = e.pageY;
					this.rotating.r = (this.rotating.r + delta + 360) % 360;
					steleActions.setRotation(this.state.options.options.idxs.parent,
							(Math.floor((this.rotating.r) / 5) * 5)
					);
				} else {
					this.rotating = null;
				}
			} else if (this.state.dragging) {
				this.setState({
					pos: {
						x: e.pageX - this.state.rel.x,
						y: e.pageY - this.state.rel.y
					}
				});
			} else if (this.globalRotation) {
				const delta = (e.pageY - this.globalRotation.y + e.pageX -this.globalRotation.x) % 360;
				this.globalRotation.x = e.pageX;
				this.globalRotation.y = e.pageY;
				this.globalRotation.r = (this.globalRotation.r + delta + 360) % 360;
				steleActions.setGlobalRotation(Math.floor((this.globalRotation.r) / 5) * 5);
			} else if (this.moveSpot) {
				// TODO x-y Startwert des spotA/B in mouseDown merken und immer relativ dazu berechnen: weil dadurch das zu
				// weit hinaus ziehen richtig behandelt wird vmBox: px/100vx hier: px	ges.: vx => 100vx = vmBox * px => 1vx =
				// vmBox/100 geg. z=5px, ges. vx => 1/(z*1vz) => 1/z*(1/1)/(vmBox/100) => 1/z*100/vmBox

				// entgegen oben: ziel ist nicht vh sondern bereich von -1 .. 1
				const vw = this.vmBox.width / 100.0;
				const vh = this.vmBox.height / 100.0;
				const deltaX =  ((e.pageX - this.moveSpot.x) / vw) / 20; // 0..2
				const deltaY =  ((e.pageY - this.moveSpot.y) / vh) / 20;
				const idxs = this.state.options.options.idxs;
				steleActions.setXY(this.moveSpot.xx + deltaX, this.moveSpot.yy + deltaY, idxs.parent, idxs.child, this.moveSpot.a);
			} else if (this.moveHeight) {
				const vh = this.vmBox.height/100.0;
				const deltaYvh =  ((e.pageY - this.moveHeight.y) / vh) / scssConfig.stele_height_vh;
				const deltaYmm = deltaYvh * scssConfig.stele_height_height_mm;
				steleActions.setHeight(10*Math.floor((this.moveHeight.height - deltaYmm)/10));
			}
			e.stopPropagation();
			e.preventDefault();
		} else {
			this.rotating = null;
			this.globalRotation = null;
			this.moveSpot = null;
			this.moveHeight = null;
			if(this.state.dragging)
				this.setState({dragging: false, dragCfg: null});
		}
	},
	onDropzoneMouseLeave: function(e) {
		if(this.state.dragging) {
			//console.log("onDropzoneMouseLeave", e, this.state.dragging);
			//steleActions.rollbackTemporary();
			steleStore.rollbackTemporary();
		} else {
			this.draggCenter = null;
			this.downIdx = null;
			this.downX = null;
			this.downY = null;
		}
	},
	onDropzoneMouseMove: function(/**MouseEvent*/e) {
		//console.log("dzMM: "+e.button+", "+e.which, this.state.dragging, this.rotating, (!this.rotating && e.which === 1
		// && this.downIdxs !== null && (Math.abs(e.pageX-this.downX)>deltaClick ||
		// Math.abs(e.pageY-this.downY)>deltaClick)));
		if(this.state.dragging) {
			//if(e.buttons === 1) { // Test mit React unter Safari nicht möglich
				const idxs = this.getPartIndexFromY(this.draggCenter);
				if (idxs.parent !== null && this.state.data.active[idxs.parent]) {
					//console.log("parent "+idxs.parent + " " + (this.state.data.active[idxs.parent] !== undefined));

					if (this.state.data.active[idxs.parent].temporary)
						return;

					const lowerIndex = idxs.parent > 0 && this.state.data.active[idxs.parent - 1].temporary ? idxs.parent - 1 :
							idxs.parent < this.state.data.active.length - 1 && this.state.data.active[idxs.parent + 1].temporary ? idxs.parent : null;
					if (lowerIndex !== null) {
						const top = parentRefs[lowerIndex].top;
						const bottom = parentRefs[lowerIndex + 1].bottom;
						const posRel = (this.draggCenter - top) / (bottom - top);
						steleStore.addTemporary(this.state.draggCfg, this.draggCenter, parentRefs, posRel <= 0.5 ? lowerIndex : lowerIndex + 1, childRefs, null);
						return;
					}
				}
				steleStore.addTemporary(this.state.draggCfg, this.draggCenter, parentRefs, idxs.parent, childRefs, idxs.child);
			//} else {
			//	this.setState({dragging: false, dragCfg: null});
			//}
		} else if(this.downIdxs && !this.globalRotation && !this.rotating /* && e.which === 1 */ && this.downIdxs !== null && (Math.abs(e.pageX-this.downX)>deltaClick || Math.abs(e.pageY-this.downY)>deltaClick)) {
			//console.log(this.downIdxs);
			const idxs = this.downIdxs;
			const x = this.downX;
			const y = this.downY;

			this.downX = null;
			this.downY = null;
			this.downIdxs = null;

			if(this.state.stepdata.name === stepConfig.STEP_CONFIG) {
				if(this.state.view.viewBottom) {
					if (this.hitCharging(e)) {
						this.startDraggMoveCharging(e, x, y);
					}
				} else {
					this.startDraggMove(idxs.parent, idxs.child, e, x, y);
				}
			}
		}
	},
	onDropzoneMouseDown: function(/**MouseEvent*/ e) {
		if(this.state.stepdata.name === stepConfig.STEP_CONFIG && this.state.view.viewBottom) {
			if (this.state.data.charging.count > 0 && this.chargingRect
				&& e.pageY > this.chargingRect.top && e.pageY < this.chargingRect.bottom) {
				console.log('mouseDown auf charging', this.state.stepdata.name);
				this.downX = e.pageX;
				this.downY = e.pageY;
			} else {
				this.downX = null;
				this.downY = null;
			}
			this.downIdxs = {parent: null, child: null};
		} else {
			// erstmal nicht tun, erst wenn mind. deltaClick px bewegt
			const idxs = this.getPartIndexFromY(e.pageY);
			if (idxs.parent !== null) {
				this.downX = e.pageX;
				this.downY = e.pageY;
				this.downIdxs = idxs;
			}
		}
	},
	onDropzoneMouseUp: function(/**MouseEvent*/ e) {
		// TODO clean up all mouse functions
		//console.log("dzMouseUp: "+e.pageY+" "+this.draggCenter);
		const idxs = this.getPartIndexFromY(this.draggCenter);
		if(this.state.dragging) {
			if(idxs.parent !== null && this.state.data.active[idxs.parent]) {
				//console.log("parent "+idxs.parent + " " + (this.state.data.active[idxs.parent] !== undefined));

				if(this.state.data.active[idxs.parent].temporary) {
					this.commitTemporary(this.state.draggCfg, this.draggCenter, parentRefs, idxs.parent, childRefs, idxs.child);
					return;
				}

				const lowerIndex = idxs.parent > 0 && this.state.data.active[idxs.parent-1].temporary ? idxs.parent - 1 :
						idxs.parent < this.state.data.active.length -1 && this.state.data.active[idxs.parent+1].temporary ? idxs.parent : null;
				if(lowerIndex !== null) {
					const top = parentRefs[lowerIndex].top;
					const bottom = parentRefs[lowerIndex+1].bottom;
					const posRel = (this.draggCenter-top)/(bottom-top);
					this.commitTemporary(this.state.draggCfg, this.draggCenter, parentRefs, posRel <= 0.5 ? lowerIndex:lowerIndex+1, childRefs, null);
					return;
				}
			}
			this.commitTemporary(this.state.draggCfg, this.draggCenter, parentRefs, idxs.parent, childRefs, idxs.child);
		} else if (Math.abs(e.pageX - this.downX) <= deltaClick || Math.abs(e.pageY - this.downY) <= deltaClick) {
			// das hier wird tatsächlich nur bei Click über der Stele ausgeführt
			// nur reagieren, wenn tatsächlich das element gewechselt wird
			if (this.state.stepdata.name === stepConfig.STEP_PARAMETERS) {
				if (this.downIdxs.parent !== null && this.state.options.options.idxs !== null &&
					( this.downIdxs.parent !== this.state.options.options.idxs.parent || this.downIdxs.child !==  this.state.options.options.idxs.child)
				) {
					const newOptions = new config.Options(this.state.data.active, this.downIdxs, this.state.data.partsHeight);
					optionActions.set(newOptions);
					this.switchToParameters(newOptions);
				}
			} else { // stepConfig.STEP_CONFIG
				if(this.state.view.viewBottom) {
					if(this.hitCharging(e)) {
						optionActions.set(ChargingOptionsObject);
					}
				} else {
					const newOptions = this.state.options.options ? null : new config.Options(this.state.data.active, this.downIdxs, this.state.data.partsHeight);
					optionActions.set(newOptions);
				}
				}
		}

		this.downIdxs = null;
		this.downX = null;
		this.downY = null;
	},
	onResize: function() {
		this.forceUpdate();	// re-render to recollect refs with positions FIXME: if the refs are known, calling
		                    // getBoundingClientRect on all of them should be enough
		// rerender again to reposition option boxes and light
		// distribution
		window.setTimeout(() => {
			if(this.chargingElem) {
				this.chargingRect = this.chargingElem.getBoundingClientRect();
			}
			this.forceUpdate();
		}, 150);
	},
	getPartIndexFromY: function(y) {
		if(!parentRefs || !childRefs || parentRefs.length < 1 || !parentRefs[0] || !parentRefs[0].top || y < parentRefs[0].top) {
			//console.log("parentRefs or childRefs missing OR simply above highest element");
			return {parent: null, child: null};
		}

		const p = this.findIndexFromY(parentRefs, y);

		let c = null;
		if(p < childRefs.length && childRefs[p])
			c = this.findIndexFromY(childRefs[p], y);
		//console.log("getPartIndexFromY "+p+ " "+childRefs.length + " "+ (!!childRefs[p])+ " "+c);

		return {parent: p, child: c};
	},
	findIndexFromY: function(/**Array*/ arr, y) {
		if(arr)
			for(let i=0; i < arr.length; i++) {
				if(y > arr[i].top && y < arr[i].bottom)
					return i;
			}
		else
			console.log('arr null');
		return null;
	},
	switchToParameters: function(newOptions) {
		newOptions = newOptions instanceof config.Options ? newOptions : this.state.options.options;
		const stele=this.state.data.active;
		if(!newOptions) {
			let idxs = null;
			for(let i=0; i<stele.length && !idxs; i++) {
				if(stele[i].container) {
					if(stele[i].children.length > 0)
						idxs = {parent: i, child: 0};
				} else {
					// kein Container, also leuchtet es. Gilt nur solange sich der Deckel nicht als PART manifestiert.
					if(stele[i].name === config.PART_MODUL_RGBW_NAME)
							continue; // Akzent nur nehmen, wenn es sonst nichts gibt
					idxs = {parent: i, child: null};
				}
			}
			if(!idxs && stele.length > 0 &&
					((stele[0].name === config.PART_MODUL_RGBW_NAME))) {
				// Akzent wenn es sonst nichts gibt -> es gibt kein Wegemodul an Position 0
				idxs = {parent: 0, child: null};
			}
			if(idxs) {
				newOptions = new config.Options(stele, idxs, this.state.data.partsHeight);
				optionActions.set(newOptions);
			}
		}
		const substep = newOptions ?
				(newOptions.paramFassade ? 'params-fassade' + (newOptions.childVert === config.F_V_DOWN ? 'Down' : '') : // Test auf childType nur um Down bei narrow zu deaktivieren, Kundenwunsch 2016-11
						(newOptions.paramSpot ? 'params-ts' :
								(newOptions.paramWege ? 'params-wege' :
									(newOptions.paramGobo ? 'params-gobo' :
										(newOptions.paramVert ? 'params-vert' : '' ))))) :
				null;
		if(this.state.stepdata.name === stepConfig.STEP_PARAMETERS)
			stepActions.switchSubStep(substep);
		else
			stepActions.switchStep(stepConfig.STEP_PARAMETERS, substep);
	},
	_sizeOptionClick: function(o) {
		steleActions.changeSize(this.state.options.options.idxs.parent, o);
	},
	storeChargingRect: function(elem) {
		if(elem) {
			this.chargingElem = elem;
			this.chargingRect = elem.getBoundingClientRect();
		}
	},
	hitCharging: function (/**MouseEvent*/e) {
		return	(this.state.data.charging.count > 0 && this.chargingRect &&
			e.pageY > this.chargingRect.top && e.pageY < this.chargingRect.bottom);
	},
	renderSizeOptions: function(elems, sizes) {
		sizes.forEach( o => {
			elems.push(<SizeOption key={o.name} o={o}
			                       onItemClick={this._sizeOptionClick}
			                       selected={o.name===this.state.data.active[this.state.options.options.idxs.parent].name} />);
		}, this);
	},
	startRotatingOption: function(ev) {
		this.rotating = {r: this.state.data.active[this.state.options.options.idxs.parent].rotation, x: ev.pageX, y: ev.pageY};
	},
	renderRotationOptions: function(elems) {
		/**config.Options*/const options = this.state.options.options;
		const parent = this.state.data.active[options.idxs.parent];
		elems.push(<div key="r" className="slx-stele-options__rotation">
			<div className={'sprity-slx-stele-options__rotationsrad sprity-slx-stele-options__rotationsrad-r' + (1 + Math.floor(this.state.data.active[options.idxs.parent].rotation / 5))}
				 onMouseDown={this.startRotatingOption}
				 />
			<div className="slx-stele-options__rotationText">
				{parent.rotation+'°'}
			</div>
		</div>);
	},
	_camBosch: function() {
		steleActions.setType(config.C_BOSCH, this.state.options.options.idxs.parent);
	},
	_camAxis: function() {
		steleActions.setType(config.C_AXIS, this.state.options.options.idxs.parent);
	},
	_camEneo: function() {
		steleActions.setType(config.C_ENEO, this.state.options.options.idxs.parent);
	},
	_toggleBack: function() {
		steleActions.toggleBack(this.state.options.options.idxs.parent);
	},
	_childTypeF25: function() {
		steleActions.setType(config.F_25, this.state.options.options.idxs.parent, this.state.options.options.idxs.child);
	},
	_childTypeF45: function() {
		steleActions.setType(config.F_45, this.state.options.options.idxs.parent, this.state.options.options.idxs.child);
	},
	_wegeAmbiance: function () {
		steleActions.setSky(false, this.state.options.options.idxs.parent);
	},
	_wegeSky: function () {
		steleActions.setSky(true, this.state.options.options.idxs.parent);
	},
	_optionSpotsNone: function() {
		optionActions.setSpot(false, false);
	},
	renderOptions: function() {
		/**config.Options*/const options = this.state.options.options;
		if(!options || !(parentRefs[options.idxs.parent]||options.charging))
			return undefined;

		const parent = this.state.data.active[options.idxs.parent];
		const child = options.idxs.child !== null ? parent.children[options.idxs.child] : null;
		const box = options.charging ?
			this.chargingRect
			: (options.idxs.child !== null ? childRefs[options.idxs.parent][options.idxs.child] : parentRefs[options.idxs.parent]);
		const ret = [];
		const elems = [];
		let spotA = <div key="osA" />;
		let spotB = <div key="osB" />;

		let light = null;

		// INFO Rotation gibt es eventuell auch im parameters-schirm. wirkt dann aber umgekehrt auf die anderen elemente. 2017-04: derzeit ungenutzt
		if(this.state.stepdata.name !== stepConfig.STEP_PARAMETERS) {
			if(options.cam) {
				// TODO eventuell alphabetisch sortieren?
				// FIXME Texte für Cam
				elems.push(<div key="cBosh" className={'slx-stele-options__size' + (parent.type === config.C_BOSCH ? ' slx-stele-options__selected' : '')} onClick={this._camBosch} > {T.current.STELE.C_BOSCH} </div>);
				// cXXX
				elems.push(<div key="cAxis" className={'slx-stele-options__size' + (parent.type === config.C_AXIS ? ' slx-stele-options__selected' : '')} onClick={this._camAxis} > {T.current.STELE.C_AXIS} </div>);
				elems.push(<div key="cEneo" className={'slx-stele-options__size' + (parent.type === config.C_ENEO ? ' slx-stele-options__selected' : '')} onClick={this._camEneo} > {T.current.STELE.C_ENEO} </div>);
			} else if(options.charging) {
				chargingOptions(elems, this.state.data.charging, this.props.showInfo);
			} else {
				if (options.rotation && !options.paramWege) {
					this.renderRotationOptions(elems);
				}
				if (options.distribution) {
					elems.push(<div key="d" className="slx-stele-options__distribution"
									onClick={this.switchToParameters}>{T.current.STELE.DISTRIBUTION}</div>);
				}
				if (options.size && options.sizes) {
					this.renderSizeOptions(elems, options.sizes);
				}
				if (options.rotation && !options.paramWege) {
					elems.push(<div key="a"
									className={'slx-stele-options__backCover'+(this.state.data.active[options.idxs.parent].backCover?' slx-stele-options__checked':'')}
									onClick={this._toggleBack}>{T.current.STELE.BACKCOVER}</div>);
				}
				// TODO GOBO: 45W oder 85W. Die beiden Optionen müssen in eine Zeile
				// TODO VERT: 3000K oder 4000K. Die beiden Optionen müssen in eine Zeile
			}
		} else {
			if(options.paramFassade) {
				light = 'fassade-' + child.type + '-' + child.horiz + '-' + child.vert;
				elems.push(<div key="pf45" className={'slx-stele-options__size' + (child.type === config.F_45 ? ' slx-stele-options__selected' : '')} onClick={this._childTypeF45} > {T.current.STELE.F_WIDE} </div>);
				elems.push(<div key="pf25" className={'slx-stele-options__size' + (child.type === config.F_25 ? ' slx-stele-options__selected' : '')} onClick={this._childTypeF25} > {T.current.STELE.F_NARROW} </div>);
			} else if(options.paramSpot) {
				// TODO click und move unterscheiden -- aber wie zwischen oberem und unterem spot?
				// TODO Postionsbereich abhängig im Maßstab: jeweils auf den Bereich bis zu den weißen Linien neben der Stele
				// beschränken
				light=null;
				spotA = this.renderSpot(box, child.a, 'A', this.state.options.spotA);
				spotB = this.renderSpot(box, child.b, 'B', this.state.options.spotB);
			} else if(options.paramWege) {
				if (options.rotation) { // disabled by configuration
					this.renderRotationOptions(elems);
				} else {
					elems.push(<div key="wAmb" className={'slx-stele-options__size' + (!parent.sky ? ' slx-stele-options__selected' : '')} onClick={this._wegeAmbiance} > Tritec Ambience </div>);
					elems.push(<div key="wSkyS" className={'slx-stele-options__size' + (parent.sky  ? ' slx-stele-options__selected' : '')} onClick={this._wegeSky} > Tritec Sky</div>);
				}
				//light=parent.name+'-'+parent.type; // derzeit keine unterschiedlichen Lichtkreise, daher:
				light = 'wege-'+parent.type;
			} else if (options.paramGobo) {
				light = 'gobo-'+child.type;
			} else if (options.paramVert) {
				light = 'vert';
			}
		}

		// Keine Vorsicht vor dem unteren Rand Damit die Optionen unten raus stehen, müsste die Stele so voll gepackt sein,
		// dass unten eh nur mehr eine Option (Aufnahme250) da ist, was dann passt. Zumindest bei halbwegs tauglichen
		// schirmen TODO unteren Rand mit anderen Screens testen und falls nötig Boxen und Schriftgröße nicht in px
		// definieren, sondern auch in vh
		const top = options.size ? (box.top - 40) : (box.top + box.bottom - 40 * elems.length) / 2;
		ret.push(spotA);
		ret.push(spotB);

		if(light)
			ret.push(<img key="ol" src={'img/stele/parameters/Lichtverteilung-'+light+'.svg'} className={'slx-stele-params__'+light} style={{top: box.top + box.height/2}} />);
		else
			ret.push(<img key="ol" style={{display: 'none'}} />);

		if (elems.length >0)
			ret.push(<div key="oo" className="slx-stele-options" style={{top: top<0 ? 0 : top}}>
				         {elems}
			         </div>);
		else
			ret.push(<div key="oo" />);

		return ret;
	},
	renderSpot: function(box, spot, key, selected) {
			return (<div key={'os' + key} style={{top: box.top + (box.height/2), position: 'absolute', marginTop: '-20vh', right: '30vw', width: '40vw', height: '40vh'}} >
				<img src={'img/stele/parameters/Lichtkreis-' + spot.type + (selected ? '' : '-ohne') + '.svg'} className={'slx-stele-params__spot'+key+'-'+spot.type} style={{zIndex: (selected ? '300' : null), left: (20 + spot.x * 20) + 'vw', top: (20 + spot.y * 20) + 'vh'}} />
			</div>);
	},
	render: function() {
		const activeStele = this.state.data.active;
		const options = this.state.options.options;
		const renderParameters = (this.state.stepdata.name === stepConfig.STEP_PARAMETERS);
		const renderHeight = this.props.datasheet || (!renderParameters && (this.state.stepdata.name === stepConfig.STEP_HEIGHT));
		const steleRotation =  this.props.datasheet ? 0 :
				(renderParameters && !!options && activeStele[options.idxs.parent].rotation !== undefined) ? 360-(this.state.data.active[options.idxs.parent].rotation) : this.state.data.rotation;
		steleSVG.inverted = renderParameters;
		steleSVG.color = this.props.datasheet ? 'white' : this.state.data.finish;

		let size = 0;
		activeStele.forEach( part => {
			size+= config.PART_SIZES[part.name];
		});

		if(this.justAdded) {
			if (this.justAdded.name === config.PART_MODUL_CHARGING_NAME) {
				this.justAdded = null;
				optionActions.set(ChargingOptionsObject);
			} else if(this.state.data.lastAddedIdxs) {
				this.justAdded = null;
				optionActions.set(new config.Options(activeStele, this.state.data.lastAddedIdxs, this.state.data.partsHeight));
			} else {
				this.justAdded = null;
			}
		} else if(renderParameters && !options) {
			this.switchToParameters(); // set options if possible
		}

		// preRender SteleParts: remove flickering at scope selection and option changes
		const r=(steleRotation+(options&&!options.charging&&activeStele[options.idxs.parent].rotation?activeStele[options.idxs.parent].rotation:0))%360;
		const preRender = this.props.datasheet || !options ? <div /> : mapParts([
			new StelePart(config.PART_ELEMENT_FASSADE_500),
			new StelePart(config.PART_ELEMENT_GOBO),
			new StelePart(config.PART_ELEMENT_SPEAKER),
			new StelePart(config.PART_MODUL_KAMERA),
			//new StelePart(config.PART_ELEMENT_FASSADE_1000),
			new StelePart(config.PART_ELEMENT_VERT),
			new StelePart(config.PART_ELEMENT_TWINSPOT),
			new StelePart(config.PART_MODUL_RGBW),
			new StelePart(config.PART_MODUL_WEGE),
			new StelePart(config.PART_MODUL_WEGE2),
			new StelePart(config.PART_MODUL_AUFNAHME_250),
			new StelePart(config.PART_MODUL_AUFNAHME_500),
			new StelePart(config.PART_MODUL_AUFNAHME_1000),
			new StelePart(config.PART_MODUL_AUFNAHME_1500) ],
				'prerender-', null, r, null, null );

		const draggElement = this.state.draggCfg ? mapParts([new StelePart(this.state.draggCfg)], null, undefined, 0) :  null;
		const draggStyle =  {
			marginLeft: '-50vw',
			display: this.state.dragging ? 'block' : 'none',
			position: 'absolute',
			left: (this.state.pos.x-43)+'px', // -43 see stele-steps.scss: .slx-step-config .slx-stele, ... { left: 43px };
			top: 'calc('+this.state.pos.y+'px - '+(this.state.draggCfg?config.PART_SIZES[this.state.draggCfg.name]*scssConfig.stele2vh*0.5:0)+'vh)',
			zIndex: 100,
			// needed for div around StelePart:
			width: '100vw',
			height: 'auto'
		};

		const isStepConfig = (this.state.stepdata.name === stepConfig.STEP_CONFIG);
		const viewBottom = this.state.view.viewBottom && isStepConfig;
		const hideIfDragging = this.state.dragging ? {display: 'none'} : null;
		const bottom = this.props.datasheet ?
			renderCharging(this.state.data.charging, this.storeChargingRect, 0) :
			renderBottom(this.state.data.charging, this.storeChargingRect, steleRotation, this.state.data.extraDoors);

		return (
				<div ref="vmBox" className={'slx-stele' + (viewBottom ? ' slx-stele--viewingBottom':'')} style={this.state.dragging? {cursor: 'pointer'} : null} >
					{renderHeight && !this.props.datasheet ?
							<div key="rhdot" className="slx-stele-height__handle"
							     style={{top: ((250+scssConfig.stele_height_height_mm-this.state.data.height) * scssConfig.stele_height_vh / scssConfig.stele_height_height_mm) + 'vh'}} /> :
							<div className="slx-stele__dropzone"
							     style={this.state.dragging || viewBottom ? null : {top: 'calc(' + (100-scssConfig.stele_height_vh) + 'vh - 42px)', height: viewBottom ? null : (scssConfig.stele2vh * size) + 'vh'}}
							     ref = "dropzone"
									/>
					}
					<div style={{opacity: 0}}>{preRender}</div>
					<TheThing steleRotation={steleRotation} renderHeight={renderHeight} datasheet={this.props.datasheet} parentRefs={parentRefs} childRefs={childRefs} />
					{bottom}
					<div className="slx-stele__head__gradient" />
					<div className="slx-stele__bottom__gradient" />
					<div className="slx-stele__showHead" style={hideIfDragging} onClick={viewActions.viewHead} >{T.current.STELE.SHOW_HEAD}</div>
					<div className="slx-stele__showBottom" style={hideIfDragging} onClick={viewActions.viewBottom} >{T.current.STELE.SHOW_BOTTOM}</div>
					<div style={draggStyle} ref="draggBox">
						{draggElement}
					</div>
					{this.renderOptions()}
				</div>
		);
	}
});

